import React, { FC, useState, useEffect } from "react";
import { Employee } from "../models";
import { KeyValue } from "../../common/models";
import { Link } from "react-router-dom";
import Shifts from "./Shifts";
import {
  Card,
  Checkbox,
  FormControlLabel,
  TextField,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import orgDataService from "services/orgDataService";
import employeeService from "services/employeeService";
import { useNavigate } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import MDButton from "components/MDButton";

import { toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
export interface DriverEditProps {
  employee: Employee;
  reloadEmployee(): any;
  setEmployee(employee: Employee): any;
}

const DriverEdit: FC<DriverEditProps> = (props) => {
  const [driverTypes, setDriverTypes] = useState<KeyValue[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    orgDataService.getDriverTypes().then((results) => setDriverTypes(results));
  }, []);

  const update = function () {
    if (!props.employee) return;

    employeeService.updateDriver(props.employee.driver).then(() => toast.success("Driver Updated"));
  };

  return (
    props.employee?.driver && (
      <>
        <Grid item xs={12} mt={1}>
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h5">Driver General Info</MDTypography>
            </MDBox>
            <MDBox component="form" pb={3} px={3}>
            <Grid container spacing="2">
              <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="text">
                  <b>
                    Home Phone
                    <Tooltip title="Update in Paycom">
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    :
                  </b>{" "}
                  {props.employee.driver.homePhone1 ? (
                    <a href={"tel:" + props.employee.driver.homePhone1.replace(/\D/g, "")}>
                      {props.employee.driver.homePhone1}
                    </a>
                  ) : (
                    "N/A"
                  )}{" "}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="text">
                  <b>
                    Home Phone 2
                    <Tooltip title="Update in Paycom">
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    :
                  </b>{" "}
                  {props.employee.driver.homePhone2 ? (
                    <a href={"tel:" + props.employee.driver.homePhone2.replace(/\D/g, "")}>
                      {props.employee.driver.homePhone2}
                    </a>
                  ) : (
                    "N/A"
                  )}{" "}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="text">
                  <b>
                    Cell Phone
                    <Tooltip title="Update in Paycom">
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    :
                  </b>{" "}
                  {props.employee.driver.cellPhone ? (
                    <a href={"tel:" + props.employee.driver.cellPhone.replace(/\D/g, "")}>
                      {props.employee.driver.cellPhone}
                    </a>
                  ) : (
                    "N/A"
                  )}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4}>
                <MDTypography variant="body2" color="text">
                  <b>
                    Location
                    <Tooltip title="Update in Paycom">
                      <IconButton size="small">
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                    :
                  </b>{" "}
                  {props.employee.driver.hubName ?? "N/A"}
                </MDTypography>
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2 }}>
                <TextField
                  inputProps={{ type: "tel", maxLength: "5" }}
                  value={props.employee.driver.hoursOfRest}
                  label="Hours Of Rest"
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      driver: { ...props.employee.driver, hoursOfRest: +e.target.value },
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2 }}>
                <FormControl>
                  <InputLabel>Driver Type</InputLabel>
                  <Select
                    id="driver.typeId"
                    sx={{ minWidth: 210 }}
                    label="Driver Type"
                    value={props.employee.driver.typeId}
                    onChange={(e) =>
                      props.setEmployee({
                        ...props.employee,
                        driver: { ...props.employee.driver, typeId: +e.target.value },
                      })
                    }
                  >
                    {driverTypes &&
                      driverTypes.map((dt, index) => (
                        <MenuItem key={index} value={dt.id}>
                          {dt.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2, pr: 2 }}>
                <TextField
                  value={props.employee.driver.otherDriverInfo}
                  inputProps={{ maxLength: 30 }}
                  label="Other Driver Info"
                  fullWidth
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      driver: { ...props.employee.driver, otherDriverInfo: e.target.value },
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.employee.driver.allowExternalDevice}
                      onChange={(e) =>
                        props.setEmployee({
                          ...props.employee,
                          driver: {
                            ...props.employee.driver,
                            allowExternalDevice: !props.employee.driver.allowExternalDevice,
                          },
                        })
                      }
                    />
                  }
                  label="Allow External Device"
                />
              </Grid>
              <Grid item xs={12} md={4} sx={{ mt: 2 }}>
                <FormControlLabel
                  sx={{ minWidth: 210 }}
                  control={<Checkbox checked={props.employee.driver.suspended} />}
                  label="Suspended"
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      driver: { ...props.employee.driver, suspended: !props.employee.driver.suspended },
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={8} sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  value={props.employee.driver.suspendedReason}
                  inputProps={{ maxLength: 500 }}
                  label="Suspended Reason"
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      driver: { ...props.employee.driver, suspendedReason: e.target.value },
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  value={props.employee.driver.comments}
                  inputProps={{ maxLength: 255 }}
                  label="Comments"
                  onChange={(e) =>
                    props.setEmployee({
                      ...props.employee,
                      driver: { ...props.employee.driver, comments: e.target.value },
                    })
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} justifyItems="space-between">
              <Grid container spacing={2} sx={{ pt: 2, pb: 2, pr: 4 }}>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <MDButton variant="text" color="secondary" to="/employees" component={Link}>
                    Cancel
                  </MDButton>
                  <MDButton variant="contained" color="dark" disabled={!props.employee?.driver} onClick={update}>
                    Update
                  </MDButton>
                </Grid>
              </Grid>
            </Grid>
            </MDBox>
          </Card>
        </Grid>
      </>
    )
  );
};

export default DriverEdit;
